module.exports = __webpack_public_path__ + "img/logo-small.fac5de8f.svg";